import React from 'react';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
import GraduationHatSVG from '@package/svgs/icons/graduation-hat.svg';
import View from './View';
import LectureBlockSchema from './schema';

const Edit = (props) => {
  const schema = LectureBlockSchema(props.intl);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={GraduationHatSVG} />}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View data={props.data} isEditMode={true} />
    </>
  );
};

export default Edit;
